<div class="employment-conditions-confirmation-list container">
  <div class="content">
    <div class="content-card filters">
      <div class="top">
        <div class="top__left">
          <button mat-raised-button color="accent" [matMenuTriggerFor]="menu" [visibleWithPermissions]="['SignEmploymentConditionsConfirmation']">
            {{ 'WL-Actions' | translate }}
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onDownloadSelectedDocumentsBtnClick()" [disabled]="!isDownloadSelectedDocumentsBtnEnabled()">
              <span [matTooltip]="'EmploymentConditionsConfirmationList.DownloadSelectedDocumentsTooltip' | translate">{{
                'EmploymentConditionsConfirmationList.DownloadSelectedDocuments' | translate
              }}</span>
            </button>
          </mat-menu>
        </div>
        <div class="top__right">
          @if (showFilterPresetSelector) {
            <mat-form-field [@inOutAnimation] appearance="outline" class="filter-preset-selector">
              <mat-label>Filtr</mat-label>
              <mat-select [value]="selectedFilterPresetId" (valueChange)="setSelectedFilterPresetId($event)">
                @for (preset of filterPresets; track preset) {
                  <mat-option [value]="preset.Id">{{
                    preset.Name === defaultFilterPresetName ? ('DefaultFilterPresetName' | translate) : preset.Name
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <button
            [matTooltip]="'EmploymentConditionsConfirmationList.AddSignedDocumentInfo' | translate"
            [visibleWithPermissions]="['SignEmploymentConditionsConfirmation']"
            mat-raised-button
            (click)="onAddSignedDocumentButtonClick()"
            color="accent"
            class="add-signed-document-button"
            >
            {{ 'EmploymentConditionsConfirmationList.AddSignedDocument' | translate }}
          </button>
          <button (click)="resetFilters()" class="top__button top__button-clear">
            <mat-icon>close</mat-icon>
            {{ 'Reset' | translate }}
          </button>
          <button (click)="toggleFiltersPanel()" class="top__button top__button-filter">
            <mat-icon>filter_alt</mat-icon>
            {{ 'Filter' | translate }}
          </button>
        </div>
      </div>
      @if (areFiltersExpanded) {
        <app-employment-conditions-confirmation-list-filters
          [formGroup]="filtersFormGroup"
          (filterGridData)="filterData($event)"
          [hasLegalization]="hasLegalization"
          >
          <div class="favorite-button-row-container">
            <button (click)="saveFilterPresetButtonClick()" class="favorite-button">
              @if (isSavedFilterPreset) {
                <mat-icon>bookmark</mat-icon>
                {{ 'UnsaveFilter' | translate }}
              } @else {
                <mat-icon>bookmark_border</mat-icon>
                {{ 'SaveFilter' | translate }}
              }
            </button>
          </div>
        </app-employment-conditions-confirmation-list-filters>
      }
    </div>

    <div class="content-card" [ngClass]="{ 'filters-opened': areFiltersExpanded }">
      <div #tableContainer class="wrapper custom-table">
        <cdk-virtual-scroll-viewport gridTableVirtualScroll (scrolledIndexChange)="nextBatch($event)">
          <mat-table
            class="table"
            matSort
            matSortActive="CreatedOn"
            matSortDirection="desc"
            matSortDisableClear
            [dataSource]="dataSource"
            (matSortChange)="onSortChange()"
            [trackBy]="trackBy"
            >
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select" sticky>
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  appearance="outline"
                  (change)="onSelectAllChxChange()"
                  [checked]="dataSource.selection.hasValue() && isAllSelected()"
                  [indeterminate]="dataSource.selection.hasValue() && !isAllSelected()"
                  [matTooltip]="'SelectAll' | translate"
                  matTooltipPosition="above"
                  >
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="onRowChxChange($event, row)"
                  [checked]="dataSource.selection.isSelected(row)"
                  >
                </mat-checkbox>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="WorkerFullName" [sticky]="screenService.isAboveMd$ | async">
              <mat-header-cell *matHeaderCellDef mat-sort-header="LastName" class="hidden-sort">
                {{ 'EmploymentConditionsConfirmationList.WorkerFullName' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                ><a
                class="user"
                [routerLink]="['/profile/' + element.WorkerId]"
                [matTooltip]="'WL-ShowWokerProfile' | translate"
                matTooltipPosition="above"
                >{{ element.FullName }}</a
                >
              </mat-cell>
            </ng-container>            <ng-container matColumnDef="CompanyName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'EmploymentConditionsConfirmationList.CompanyName' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.CompanyName }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="EmployerName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'EmploymentConditionsConfirmationList.EmployerName' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.EmployerName }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="EmployerObjectName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'EmploymentConditionsConfirmationList.EmployerObjectName' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.EmployerObjectName }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="EmploymentType">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'EmploymentConditionsConfirmationList.EmploymentType' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.EmploymentType }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="AgreementType">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'EmploymentConditionsConfirmationList.AgreementType' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.AgreementType }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="ConclusionDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'EmploymentConditionsConfirmationList.ConclusionDate' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.ConclusionDate | date : 'yyyy-MM-dd' }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="EmploymentDateFrom">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'EmploymentConditionsConfirmationList.EmploymentDateFrom' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.EmploymentDateFrom | date : 'yyyy-MM-dd' }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="ShareDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'EmploymentConditionsConfirmationList.ShareDate' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.ShareDate | date : 'yyyy-MM-dd' }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="FirstDownloadDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'EmploymentConditionsConfirmationList.FirstDownloadDate' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.FirstDownloadDate | date : 'yyyy-MM-dd' }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="EmploymentConditionsConfirmationStatus">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'EmploymentConditionsConfirmationList.EmploymentConditionsConfirmationStatus' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div
                class="label"
                [class.label--green]="element.EmploymentConditionsConfirmationStatusId === employmentConditionsConfirmationStatusEnum.Read"
                [class.label--blue]="element.EmploymentConditionsConfirmationStatusId === employmentConditionsConfirmationStatusEnum.Signed"
                [class.label--yellow]="element.EmploymentConditionsConfirmationStatusId === employmentConditionsConfirmationStatusEnum.Generated"
                >
                <span class="label__dot"></span>
                <span class="label__name">{{ element.EmploymentConditionsConfirmationStatus }}</span>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Actions" stickyEnd>
            <mat-header-cell *matHeaderCellDef>{{ 'WAD-Actions' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ng-container> </ng-container>
              @if (screenService.isAboveMd$ | async) {
                <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
                  <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                </button>
              } @else {
                <button mat-icon-button [matMenuTriggerFor]="menuRow">
                  <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                </button>
              }


              <mat-menu #menuRow="matMenu" panelClass="actions-menu">
                <button
                  mat-button
                  (click)="onShowDocumentClick(element.EmploymentConditionsConfirmationId, element.EmploymentConditionsConfirmationFileName)"
                  >
                  <mat-icon class="material-icons-outlined">find_in_page</mat-icon>
                  <span class="button-text">{{ 'EmploymentConditionsConfirmationList.ShowDocument' | translate }}</span>
                </button>

                <button
                  mat-button
                  (click)="onDownloadDocumentClick(element.EmploymentConditionsConfirmationId, element.EmploymentConditionsConfirmationFileName)"
                  >
                  <mat-icon class="material-icons-outlined">file_download</mat-icon>
                  <span class="button-text">{{ 'EmploymentConditionsConfirmationList.DownloadDocument' | translate }}</span>
                </button>
                <!-- <button
                mat-button
                *ngIf="isSignDocumentButtonVisible(element)"
                (click)="onSignDocumentClick(element.EmploymentConditionsConfirmationId)"
                >
                <mat-icon class="material-icons-outlined">photo_filter</mat-icon>
                <span class="button-text">{{ 'EmploymentConditionsConfirmationList.SignDocument' | translate }}</span>
              </button> -->
            </mat-menu>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="progress">
          <mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
            <mat-progress-bar [mode]="dataSource.isLoading ? 'indeterminate' : 'determinate'" class="table-progress" color="accent">
            </mat-progress-bar>
          </mat-header-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: sticky" [style.top.px]="offset$ | async"></mat-header-row>
        <mat-header-row *matHeaderRowDef="['progress']; sticky: sticky" class="progress" [style.top.px]="(offset$ | async) + 56">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
<app-item-counter class="item-counter" [position]="scrollItemPosition" [length]="dataSource.absoluteDataLength"></app-item-counter>
</div>
</div>
